import { FC } from 'react'

import { Paper, Theme } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'

// eslint-disable-next-line import/no-cycle
import { SearchCatDescriptionProps } from './index'

const useStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      categoryDescription: {
        marginTop: '12px',
        maxWidth: '100%',
        flexBasis: '100%',
        padding: '16px',
        whiteSpace: 'pre-wrap',

        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      }
    }),
  {
    name: 'SearchCategoryDescription'
  }
)

const SearchDesktopCatDesc: FC<SearchCatDescriptionProps> = ({
  catDescription,
  subCatDescription
}) => {
  const s = useStyle()

  const description = subCatDescription || catDescription

  if (!description) return <></>

  return <Paper className={s.categoryDescription}>{description}</Paper>
}

export default SearchDesktopCatDesc
